import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, LOCALE_ID } from '@angular/core';
import { ThemeComponent } from './theme/theme.component';
import { LayoutModule } from './theme/layouts/layout.module';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ScriptLoaderService } from "./_services/script-loader.service";
import { ThemeRoutingModule } from "./theme/theme-routing.module";
import { AuthModule } from "./auth/auth.module";
import { GlobalErrorHandler } from "./_services/error-handler.service";
import { HttpModule } from "@angular/http";
import { FormsModule } from "@angular/forms";
// import { MediaService } from "./_services/media.service";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {ToppostsService} from "./_services/topposts.service";
import {TopsectionsService} from "./_services/topsections.service";
import {LastpostsService} from "./_services/lastposts.service";
import {OriginService} from "./_services/origin.service";
import {VisitsService} from "./_services/visits.service";
import {ReferrerService} from "./_services/referrer.service";
import {SocialService} from "./_services/social.service";

@NgModule({
    declarations: [
        ThemeComponent,
        AppComponent
    ],
    imports: [
        LayoutModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        ThemeRoutingModule,
        AuthModule,
        HttpModule,
        FormsModule,
        NgbModule.forRoot()
    ],
    providers: [
        ScriptLoaderService,
        // MediaService,
        ToppostsService,
        TopsectionsService,
        LastpostsService,
        OriginService,
        VisitsService,
        ReferrerService,
        SocialService,
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler },
        { provide: LOCALE_ID,
            useValue: 'es-ES' }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// /home/node/src/app/app.module.ts